import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import Vant from "vant";
// import "vant/lib/index.css";
import "@/vant";
import "amfe-flexible";
import Axios from "axios";
import VueAxios from "vue-axios";
import VueWechatTitle from "vue-wechat-title";
import "./assets/css/reset.css";
import "./assets/css/common.css";

Vue.use(VueWechatTitle);
// Vue.use(Vant);
Vue.use(VueAxios, Axios);
Vue.config.productionTip = false;
// if (process.env.NODE_ENV === 'development') {
//   Vue.config.silent = false
//   Vue.config.devtools = true
// } else if (process.env.NODE_ENV === 'production') {
//   Vue.config.silent = true
//   Vue.config.devtools = true
// }
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
